import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid skin-body"
}
const _hoisted_2 = { class: "row mt-2" }
const _hoisted_3 = { class: "col-lg-8 mx-auto" }
const _hoisted_4 = { class: "container-fluid skin-body mb-5" }
const _hoisted_5 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_admin_bar = _resolveComponent("admin-bar")!
  const _component_top_bar = _resolveComponent("top-bar")!
  const _component_bad_response_viewer = _resolveComponent("bad-response-viewer")!
  const _component_user_home = _resolveComponent("user-home")!
  const _component_you = _resolveComponent("you")!
  const _component_requirements = _resolveComponent("requirements")!
  const _component_DBOptions = _resolveComponent("DBOptions")!
  const _component_income = _resolveComponent("income")!
  const _component_life = _resolveComponent("life")!
  const _component_design = _resolveComponent("design")!
  const _component_test = _resolveComponent("test")!
  const _component_finish = _resolveComponent("finish")!
  const _component_options = _resolveComponent("options")!
  const _component_dashboard = _resolveComponent("dashboard")!
  const _component_guiide_plus = _resolveComponent("guiide-plus")!
  const _component_support = _resolveComponent("support")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(["mx-auto mb-5 pb-5 mb-md-0 pb-md-0", { narrowMain: _ctx.restrictWidth }])
  }, [
    (_ctx.showAdminBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_admin_bar)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showTopBar)
      ? (_openBlock(), _createBlock(_component_top_bar, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_bad_response_viewer, {
          ref: "badResponseViewer",
          messagePrefix: "Please refresh the page. Unable to recover your latest information because: "
        }, null, 512),
        (_ctx.showUserHome)
          ? (_openBlock(), _createBlock(_component_user_home, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.showYou)
          ? (_openBlock(), _createBlock(_component_you, { key: 1 }))
          : _createCommentVNode("", true),
        (_ctx.showRequirements)
          ? (_openBlock(), _createBlock(_component_requirements, { key: 2 }))
          : _createCommentVNode("", true),
        (_ctx.showDBOptions)
          ? (_openBlock(), _createBlock(_component_DBOptions, { key: 3 }))
          : _createCommentVNode("", true),
        (_ctx.showIncome)
          ? (_openBlock(), _createBlock(_component_income, { key: 4 }))
          : _createCommentVNode("", true),
        (_ctx.showLife)
          ? (_openBlock(), _createBlock(_component_life, { key: 5 }))
          : _createCommentVNode("", true),
        (_ctx.showDesign)
          ? (_openBlock(), _createBlock(_component_design, { key: 6 }))
          : _createCommentVNode("", true),
        (_ctx.showTest)
          ? (_openBlock(), _createBlock(_component_test, { key: 7 }))
          : _createCommentVNode("", true),
        (_ctx.showFinish)
          ? (_openBlock(), _createBlock(_component_finish, { key: 8 }))
          : _createCommentVNode("", true),
        (_ctx.showOptions)
          ? (_openBlock(), _createBlock(_component_options, { key: 9 }))
          : _createCommentVNode("", true),
        (_ctx.showDashboard)
          ? (_openBlock(), _createBlock(_component_dashboard, { key: 10 }))
          : _createCommentVNode("", true),
        (_ctx.showGuiidePlus)
          ? (_openBlock(), _createBlock(_component_guiide_plus, { key: 11 }))
          : _createCommentVNode("", true),
        (_ctx.showSupport)
          ? (_openBlock(), _createBlock(_component_support, { key: 12 }))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showFooter)
      ? (_openBlock(), _createBlock(_component_Footer, {
          key: 2,
          "padding-top": 0,
          "margin-top": 0
        }))
      : _createCommentVNode("", true)
  ], 2))
}